import ShowLoadFileInfo from './ShowLoadFileInfo';

export default ShowLoadFileInfo;
